export default {
  login: {
    wrong_password: "ผ่านไม่ผ่าน",
    enter_email: "กรอกอีเมล",
  },

  about: {
    version: "เวอร์ชัน",
    about_system: "แนะนำให้ใช้เบราว์เซอร์ระบบนี้",
    display_resolution: "ความละเอียดหน้าจอ",
    package_details: "แพ็กเกจ",
    remaining_valid_days: "เหลืออยู่:",
    remaining_device_count: "จำนวนที่เหลือ:",
    no_used: "จำนวนการใช้งาน:",
    total_no_limit: "จำนวนรวมของขีดจำกัด:",
  },

  company: {
    company_profile: "โปรไฟล์",
    name: "ชื่อ :",
    code: "รหัส :",
    phone: "เบอร์ :",
    email: "อีเมล :",
    first_name: "ชื่อ :",
    last_name: "นามสกุล :",
    mobile_number: "หมายเลขโทรศัพท์ :",
    city: "เมือง :",
    country: "ประเทศ :",
    address: "ที่อยู่ :",
    mobile: "เบอร์มือถือ :",
    state: "จังหวัด/เมือง :",
  },

  retail_client: {
    add_retail_client: "เพิ่มลูกค้าปลีก",
    edit_retail_client: "แก้ไขลูกค้าปลีก",
    view_retail_client: "ดูลูกค้าปลีก",
    retail_client_name: "ชื่อลูกค้าปลีก",
    retail_client_code: "รหัสลูกค้าปลีก",
    retail_admin_email: "อีเมลผู้ดูแลระบบปลีก",
    retail_client_first_name: "ชื่อผู้ดูแลระบบปลีก",
    retail_client_last_name: "นามสกุลผู้ดูแลระบบปลีก",
    number_of_devices: "จำนวน",
    subscription_start_date: "วันเริ่มต้นการสมัคร",
    subscription_expire_date: "วันหมดอายุการสมัคร",
    select_one_retail: "ลูกค้าปลีกที่ต้องการ",
  },

  template: {
    view_template: "เทมเพลต",
    add_template: "เพิ่มเทมเพลต",
    edit_template: "แก้ไขเทมเพลต",
    template_editor: "แก้ไขเทมเพลต",
    name: "ชื่อเทมเพลต",
    resolution: "ความละเอียด",
    type: "ประเภทเทมเพลต",
    screen_direction: "ทางหน้าจอ",
    preview: "อย่างเทมเพลต",
    screen_model: "รุ่นหน้าจอ",
    is_bind_device: "จะผูกฐานหรือไม่",
  },
  editor: {
    product_element: "องค์ประกอบค้า",
    price_pule: "กฎราคา",
    product_price: "ราคาค้า",
    product_label: "ป้ายค้า",
    quantity: "จำนวน",
    category1: "หมวด1",
    category2: "หมวด2",
    currency: "สกุลเงิน",
    origin: "แหล่งกำเนิด",
    manufacturer: "ผู้ผลิต",
    discount_price: "ราคาส่วนลด",
    barcode: "บาร์โค้ด",
    company_logo: "โลโก้",
    basic_tags: "แท็กพื้นฐาน",
    image_library: "คลังภาพ",
    change_rule: "เปลี่ยนกฎ",
    free_text: "ข้อความ",
    add_label: "เพิ่มป้าย",
    add_shape: "เพิ่มรูปทรง",
    delete_element: "ลบองค์ประกอบ",
    rounded_corners: "โค้ง:",
    content_example: "อย่างเนื้อหา",
    bgcolor: "สีพื้นหลัง:",
    show_border: "แสดงขอบ:",
    show_scale: "แสดงขนาด:",
    show_value: "แสดงค่า:",
    font_color: "สีตัวอักษร:",
    font_size: "ขนาดตัวอักษร:",
    font_style: "สไตล์ตัวอักษร",
    font_weight: "น้ำหนักตัวอักษร:",
    font: "แบบตัวอักษร:",
    spacing: "ระยะห่าง:",
    rotation_angle: "หมุน:",
    width: "ความกว้าง:",
    height: "ความสูง:",
    opacity: "ความทึบแสง:",
    line_color: "สีเส้น:",
    foreground_color: "สี前景:",
    level: "ระดับ",
    color: "สี",
    shape: "รูปทรง",
    line_height: "ความสูงของเส้น",
    content: "เนื้อหา",
    qrcode: " QrCode",
    image: "ภาพ",
    textBox: "กล่องข้อความ",
  },

  openAPI: {
    open_api_client: "ไคลเอ็นต์ API เปิด",
    add_open_api: "เพิ่มไคลเอ็นต์ API เปิด",
    secret_key: "คีย์",
  },

  picture_library: {
    picture_library: "คลังภาพ",
    add_picture: "เพิ่มภาพ",
    edit_picture: "แก้ไขภาพ",
    name: "ชื่อภาพ",
    id: "ภาพ",
    preview: "อย่างภาพ",
    type: "ประเภทภาพ",
    size: "ขนาดภาพ",
    progressing: "ประมวลผลภาพ",
    general_user: "ใช้ได้",
    company_logo: "โลโก้",
    original_image: "ภาพต้นฉบับ",
    dithering_image: "ภาพดithering",
  },
  dashboard: {
    welcome_back: "ยินดีต้อนรับ!",

    login_for_next:

      "การหมดอายุแล้ว สามารถเข้าระบบครั้งต่อไปได้",

    days_only: "เท่ากับ",

    subscription_expires: "การหมดอายุใน",

    title: "NuTag แดชบอร์ด",
    from_date: "ตั้งแต่วัน",
    period: "ระยะเวลา",
    registered_gateway: "เกตเวย์",
    registered_ESL: "ESL",
    gateway_online_status: "สถานะเกตเวย์ออนไลน์",
    last_refreshed: "เฟรชครั้งล่าสุด",
    refresh_success_rate: "ความสำเร็จในการเฟรช",
    total_refreshes: "การเฟรชทั้งหมด",
    total_number: "จำนวนการเดต ESL ทั้งหมดภายในระยะเวลา",
    refreshes: "การเฟรชทั้งหมด",
    devices_distribution: "การกระจาย",
    esl_total_stores: "จำนวนร้านค้า ESL เทียบจำนวนร้านค้าทั้งหมด",
    esl_stores: "ร้านค้าที่ตั้ง ESL",
    total_stores: "จำนวนร้านค้าทั้งหมด",
    refresh_events: "การเฟรชเวนต์",
    time_in_hours: "เวลาเป็นชั่วโมง",
    refresh_time: "เวลารีเฟรช",
    success_rate: "ความสำเร็จ",
    day: "วัน",
    store: "ร้านค้า",
    all_stores: "ร้านค้าทั้งหมด",
    apply_filters: "ใช้กรอง",
    period_from_date: "ระยะเวลาตั้งแต่วัน",
    stores_installed: "ร้านค้าที่ตั้ง",
    period_to_date: "ระยะเวลา",
    select_store: "เลือกร้านค้า",
  },

  authorization: {
    title: "การอนุมัติ",
    add: "เพิ่มการอนุมัติ",
    edit: "แก้ไขการอนุมัติ",
    view: "ดูการอนุมัติ",
    name: "ชื่อการอนุมัติ",
    list: "รายการการอนุมัติ",
  },

  product: {
    title: "ข้อมูลสินค้า",
    add_product_label: "เพิ่มฉลากสินค้า",
    sku: "SKU ของสินค้า",
    category_level1: "หมวด1",
    category_level2: "หมวด2",
    category_level3: "หมวด3",
    currency_symbol: "สัญลักษณ์สกุลเงิน",
    brand_name: "ชื่อแบรนด์",
    origin_of_product: "ต้นกำเนิดของสินค้า",
    product: "สินค้า",
    add_product: "เพิ่มสินค้า",
    view_product: "ดูสินค้า",
    edit_product: "แก้ไขสินค้า",
    product_picture: "ภาพสินค้า",
    product_price: "ราคาสินค้า",
    discount_price: "ราคาส่วนลด",
    serial_number: "หมายเลขซีเรียล",
    number_one: "1",
    coca_cola: "Coca Cola",
    drink: "เครื่องดื่ม",
    cold_drink: "เครื่องดื่มเย็น",
    number_two: "2",
    model: "รุ่น :",
    inc_screen_iD: "หมายเลขหน้าจอ Inc :",
    position_no: "หมายเลขตำแหน่ง :",
    resolution: "ความละเอียด :",
    rgb_settins: "RGB การแสง",
    please_select_light: "โปรดเลือกแสง",
    select_product: "โปรดเลือกสินค้า",
    "total_work_time": "เวลาทำงานรวมของไฟ LED (นาที)",
    "duration_time": "กรอกเวลาที่ยาวนาน",
    "color_rgba": "สีไฟ RGB"

  },

  outlet: {
    title: "ร้านจำหน่ายค้า",
    add_outlet: "เพิ่มร้านจำหน่ายค้า",
    edit_outlet: "แก้ไขร้านจำหน่ายค้า",
    view_outlet: "ดูร้านจำหน่ายค้า",
    name: "ชื่อร้านจำหน่าย",
    code: "รหัสร้านจำหน่าย",
    selected_outlet: "เลือกร้านค้าแล้ว",
  },

  user: {
    name: "ผู้ใช้",
    person_list: "รายชื่อบุคคล",
    create_person: "สร้าง",
    edit_person: "แก้ไข",
    view_person: "ดู",
    person_name: "ชื่อบุคคล",
    person_Id: "ประจำ",
    user_profile: "โปรไฟล์ผู้ใช้",
    person_avatar: "อวตาร์",
  },

  gateway: {
    gateway: "เกตเวย์",
    viewDeviceDetails: "ดูรายละเอียด",
    addDeviceToOutlet: "เพิ่ม",
    bindDeviceToOutlet: "ผูก",
    gatewaySerialNumber: "หมายเลขเกตเวย์",
    gatewayName: "ชื่อเกตเวย์",
    gatewayIPAddress: "IP เกตเวย์",
    gatewayFirmware: "เฟิร์มแวร์เกตเวย์",
    gatewayRunningStatus: "สถานะการทำงานของเกตเวย์",
    gatewayUpdateTime: "เวลาอัปเดตเกตเวย์",
    outlet: "เชื่อมต่อ",
    outletTimeZone: "โซนเวลา",
    versionNumber: "หมายเลขเวอร์ชัน",
    gatewayType: "ประเภทเกตเวย์",
    gatewayModel: "รุ่นเกตเวย์",
    outletCode: "รหัสเชื่อมต่อ",
    logTime: "เวลา",
    logType: "ประเภท",
    logCode: "รหัส",
    enable: "ใช้งาน",
    deviceName: "ชื่อ",
    deviceModel: "รุ่น",
    serialNumber: "หมายเลข",
    deviceType: "ประเภท",
    outletId: "เอาท์เล็ต",
    clientName: "ชื่อไคลเอนต์",
    deviceLog: "ดู",
    view_gateway_details: "ดูเกตเวย์",
    select_version: "โปรดเลือก",
    enter_change: 'โปรดป้อนค่า 2 ช่วง ได้ 65536',
    ground_value: "ค่ากลุ่มเป็น 2 ยกเว้น 65536"
  },

  screen: {
    edit_screen: "แก้ไขหน้าจอ",
    bind_to_screen: "ผูกข้อมูลหน้าจอ",
    screenId: "หน้าจอ",
    screen_resolution: "ความละเอียดหน้าจอ",
    positionNo: "หมายเลขตำแหน่ง",
    screenName: "ชื่อหน้าจอ",
    powerStatus: "สถานะแบตเตอรี่",
    gateway: "เกตเวย์",
    outlet: "เต้าบ",
    bindToProduct: "ผูก",
    templatePreview: "อย่างเทมเพลต",

    screenStatus: "สถานะหน้าจอ",
    screenUpdateTime: "เวลาอัปเดตหน้าจอ",
    gatewaySerialNumber: "หมายเลขเกตเวย์",
    gatewayName: "ชื่อเกตเวย์",
    deviceModel: "รุ่น",
    deviceType: "ประเภท",
    gatewayRunningStatus: "สถานะเกตเวย์ทำงาน",
    unbindDevice: "ยกเลิกผูก",

    bindData: "ผูกข้อมูล",
    normal: "",
    lowPower: "แบตเตอรี่ต่ำ",
    total: "รวม",
    unbound_templates: "แม่แบบไม่ผูกไว้",
    batchUpdateScreen: "หน้าจอกลุ่มภาพ",
    same_screen: "โปรดเลือกหน้าจอ ไม่เท่ากับ",
    is_bindDevice: "โปรดระบุว่าจะให้ทำการผูกหรือไม่",
    same_advgroup: "ป้ายราคาไม่ตรงกัน",
    upgrade_device: "รายการเกรด",

    enter_valid_number: "โปรดป้อนหมายเลข ที่ใช้งานได้",
    please_enter: "โปรดป้อนไฟ LED ที่ทำงานหมด (นาที)",
    select_online_screen: "โปรดเลือกหน้าจอออนไลน์",

  },

  events: {
    price_Change_Events: "การเปลี่ยนแปลงราคา",
    add_priceChangeEvent: "เพิ่มการเปลี่ยนแปลงราคา",
    edit_priceChangeEvent: "แก้ไขการเปลี่ยนแปลงราคา",
    view_priceChangeEvent: "ดูกิจกรรมการเปลี่ยนแปลงราคา",
    priceChangeName: "ชื่อการเปลี่ยนแปลงราคา",
    priceChangeRule: "กฎการเปลี่ยนแปลงราคา",
    templateName: "ชื่อเทมเพลต",
    scheduleTime: "กำหนดเวลา",
    approvedStatus: "สถานะการอนุมัติ",
    areaFilter: "กรอง",
    outlet: "เต้าบ",
    productFilter: "กรอง",
    productElement: "องค์ประกอบ",
    brand: "แบรนด์",
    promotionType: "ประเภทโปรโมชั่น",
    templateSelection: "การเลือกเทมเพลต",
    selectTemplate: "เทมเพลตที่จะใช้ในการเปลี่ยนแปลงราคา",
    schedule: "กำหนดเวลา",
    scheduleMode: "โหมดกำหนดเวลา",
    timeZone: "โซนเวลา",
    startPromotion: "เริ่มต้น โปรโมชั่น",
    endPromotion: "สิ้นสุด โปรโมชั่น",
    doesNotEnd: "ไม่สิ้นสุด",
    setRepeatCondition: "กำหนดเงื่อนไขการทำซ้ำ",
    instantSync: "ซิงค์",
    startTime: "เวลาเริ่มต้น",
    endTime: "เวลาสิ้นสุด",
    validYear: "ต้อง",
    validMonth: "ต้อง",
    validDate: "ต้อง",
    startDate: "ต้อง",
    endDate: "ต้อง",
    days: "ต้อง",
    dates: "ต้อง",
    allDay: "ต้อง",
    approvalStatus: "สถานะอนุมัติ",
    immediateSync: "ข้อมูล",
  },

  approval: {
    approvalList: "รายการอนุมัติ",
    priceChangeDetails: "การเปลี่ยนแปลงราคา",
    viewApprovalRequest: "คำขออนุมัติของการเปลี่ยนแปลงราคา",
    approvalEvent: "เหตุการณ์การอนุมัติ",
    maker: "สร้าง",
    approvalStatus: "สถานะอนุมัติ",
    createTime: "สร้างเวลา",
    priceChangeName: "ชื่อการเปลี่ยนแปลงราคา",
    productFilter: "กรอง",
    priceChangeRule: "กฎการเปลี่ยนแปลงราคา",
    priceChangeRuleName: "ชื่อกฎการเปลี่ยนแปลงราคา",
    templateSelection: "การเลือกเทมเพลต",
    templateName: "ชื่อเทมเพลต",
    schedule: "กำหนดการ",
    timeZone: "โซนเวลา",
    startTime: "เวลาเริ่มต้น",
    endTime: "เวลาสิ้นสุด",
    setRepeatCondition: "กำหนดเงื่อนไขการทำซ้ำ",
    includeExcludeDays: "รวม/ไม่รวม",
    approve: "อนุมัติ",
    reject: "ปฏิเสธ",
    rejectUpper: "ปฏิเสธ",
    approveUp: "อนุมัติ",
    approvalLog: "การอนุมัติ",
    approvalLogEvent: "เหตุการณ์การอนุมัติ",
    approvalLogPerson: "อนุมัติ",
    approvalLogApprovalTime: "เวลาอนุมัติ",
    approvalLogStatus: "สถานะการอนุมัติ",
  },

  synchronized: {
    systemRecords: "Sึกระบบ",
    resendPriceEvent: "ส่งเหตุการณ์การเปลี่ยนแปลงราคา",

    screenID: "หน้าจอ",
    outlet: "ทางออก",
    product: "สินค้า",
    deviceSN: "SN หน้าจอ",
    status: "สถานะ",
    picture: "ภาพ",

    // 新增
    mobile: "มือถือ",
    address: "ที่อยู่",
    country: "ประเทศ",
    stateProvince: "จังหวัด/เมือง",
    city: "เมือง",
    noRecordFound: "ไม่พบข้อมูล",
    clear: "ล้าง",
    confirm: "ยืนยัน",
  },

  price: {
    promotiontype: "ประเภทโปรโมชั่น",
    number: "กรอกจำนวน",
    maximum_discount: "ส่วนลด ไม่เกิน 100%",
    select_timezone: "เลือกเขตเวลา",
    select_starttime: "เลือกเวลาเริ่มต้น",
    select_time: "เลือกเวลา",
    approved: "อนุมัติแล้ว",
    rejected: "ปฏิเสธ",
    deleted: "ลบแล้ว",
    last_template: "ต้นแบบที่ใช้ล่าสุด",
    select_times: "เลือกเวลา",
  },

  enum: {
    does_not_repeat: "ไม่ทำซ้ำ",
    daily: "รายวัน",
    weekly: "รายสัปดาห์",
    monthly: "รายเดือน",
    annually: "รายปี",
  },



  login_log: {
    title: "การเข้าระบบ",
    login_msg: "ข้อความเข้าระบบ",
    access_time: "เวลาเข้าระบบ",
    address: "เข้าระบบ",
    ipaddr: "IP เข้าระบบ",
    account: "เข้าระบบ",
    user_name: "ชื่อผู้ใช้เข้าระบบ",
    ipaddr_tip: "ใส่ IP",
    user_name: "ชื่อผู้ใช้",
    user_name_tip: "ใส่ชื่อผู้ใช้"
  },


  operation_log: {
    title: "การ",

    // การใช้
    server_person_add: "เพิ่มผู้ใช้",
    server_person_edit: "แก้ไขผู้ใช้",
    server_person_delete: "ลบผู้ใช้",
    server_send_email: "ส่งอีเมล",

    // การเกตเวย์
    server_device_add: "เพิ่มเกตเวย์",
    server_device_delete: "ลบเกตเวย์",
    server_device_advgroup: "กลุ่มออกอากาศป้ายราคา",

    // การป้ายราคา
    server_screen_edit: "แก้ไขป้ายราคา",
    server_screen_led_control: "ไฟ",
    server_template_post: "ผูกข้อมูล",

    // การเหตุการณ์การเปลี่ยนแปลงราคา
    server_price_change_event_add: "เพิ่มเหตุการณ์การเปลี่ยนแปลงราคา",
    server_price_change_event_edit: "แก้ไขเหตุการณ์การเปลี่ยนแปลงราคา",
    server_price_change_event_delete: "ลบเหตุการณ์การเปลี่ยนแปลงราคา",

    // การอนุมัติ
    server_approval_status: "สถานะการอนุมัติ",

    // การซิงค์
    server_screen_resend: "ส่งป้ายราคาใหม่",

    preview_title: "อย่างการ",
    method: "ทำ",
    account: "ทำ",
    ipAddr: "IP ทำ",
    address: "ทำ",
    operationTime: "เวลาทำ",
    status: "สถานะการทำ",
    accountName: "ทำ",
    accountNameTip: "ใส่ทำ",
    ipAddrName: "IP ทำ",
    ipAddrNameTip: "ใส่ IP",
    addressName: "ทำ",
    addressName: "ทำ",
    user_name: "ชื่อผู้ใช้",
    operation_method: "ทำ",
    operation_time: "เวลาทำ",
    operation_ipaddr: "IP ทำ",
    operation_execute_time: "เวลาทำ",
    operation_message: "ข้อความการทำ",
    operation_status: "สถานะการทำ",
    browser: "เบราว์เซอร์",
    system: "ระบบ",
    server_client_add: "เพิ่มลูกค้าปลีก",
    server_client_edit: "แก้ไขลูกค้าปลีก",
    server_client_delete: "ลบลูกค้าปลีก",
    server_template_add: "เพิ่มเทมเพลต",
    server_template_edit: "แก้ไขเทมเพลต",
    server_template_delete: "ลบเทมเพลต",
    server_third_party_app_add: "เพิ่มไคลเอนต์ API",
    server_picture_library_add: "เพิ่มภาพ",
    server_picture_library_edit: "แก้ไขภาพ",
    server_picture_library_delete: "ลบภาพ",
    server_mobile_version_add: "เพิ่มแอปพลิเคชันมือถือ",
    server_mobile_version_edit: "แก้ไขแอปพลิเคชันมือถือ",
    server_mobile_version_delete: "ลบแอปพลิเคชันมือถือ",
    server_role_add: "เพิ่มกลุ่ม",
    server_role_edit: "แก้ไขกลุ่ม",
    server_role_delete: "ลบกลุ่ม",
    server_approval_add: "เพิ่มกระบวนการอนุมัติ",
    server_approval_edit: "แก้ไขกระบวนการอนุมัติ",
    server_approval_delete: "ลบกระบวนการอนุมัติ",
    server_attribute_add: "เพิ่มข้อมูล",
    server_attribute_delete: "ลบข้อมูล",
    server_outlet_add: "เพิ่มร้านค้า",
    server_outlet_edit: "แก้ไขร้านค้า",
    server_outlet_delete: "ลบร้านค้า",
    server_product_add: "เพิ่มสินค้า",
    server_product_edit: "แก้ไขสินค้า",
    server_product_delete: "ลบสินค้า",
    server_product_upload: "อัปโหลดไฟล์",
    server_product_led_control: "ควบคุมไฟ LED"
  },

};
